import { background, clearRecordAlarms, storage } from "../extension/utils";
import { ContentActionType } from "../extension/content/actions/types";
import { CONTENT_CONTROL_BAR_ID, CONTENT_ROUNDED_CAMERA_ID } from "../extension/content/const";

export const stopRecording = async () => {
    await clearRecordAlarms();
    const recordData = await storage.getRecordData();
    background.sendMessage(recordData.controlBarTabId ?? 0, {
        action: ContentActionType.RemoveContentUI,
        body: { contentId: CONTENT_CONTROL_BAR_ID },
    });
    recordData.tabsWithCamera?.forEach(id => {
        background.sendMessage(
            id,
            {
                action: ContentActionType.RemoveContentUI,
                body: { contentId: CONTENT_ROUNDED_CAMERA_ID },
            }
        );
    });
    await storage.removeTabsWithCamera();
    await storage.setRecordData({ isDesktopWebcamRecording: false, isRecording: false, isControlBar: false });
}